module.exports = __webpack_public_path__ + "static/media/apple.bc8f125a.svg";